export default __webpack_public_path__ + "static/develop-8b507901c15511e3f19472ff8674d895.jpg";